import React, { useMemo } from 'react';
import ContentGridView from './ContentGridView';

const VideoBySectionView = ({ content, reportId, excludedContentIds = [], onContentExcluded, sortBy = 'views-high', onSortChange }) => {
  // Filter out excluded content first, then group by platform.
  // Instagram + Twitter are intentionally handled by SocialMediaBySectionView,
  // so they're filtered out here even if they slip through in the input list.
  const groupedByPlatform = useMemo(() => {
    const groups = {};
    const filteredContent = content.filter(
      video => !excludedContentIds.includes(video.id) &&
        !['instagram', 'twitter'].includes((video.platform || '').toLowerCase())
    );

    filteredContent.forEach(video => {
      const platform = video.platform?.toLowerCase() || 'other';
      if (!groups[platform]) {
        groups[platform] = [];
      }
      groups[platform].push(video);
    });

    return groups;
  }, [content, excludedContentIds]);

  const platformOrder = ['tiktok', 'youtube'];
  const platformLabels = {
    youtube: 'YouTube Videos',
    tiktok: 'TikTok Videos',
    twitch: 'Twitch VODs',
    other: 'Other Platform Videos'
  };

  // Get platforms in order, filter to only those with content
  const platformsToShow = platformOrder.filter(p => groupedByPlatform[p]?.length > 0);

  return (
    <div className="space-y-6">
      {platformsToShow.map(platform => (
        <div key={platform} className="space-y-2">
          {/* Compact Platform Header */}
          <div className="flex items-center justify-between bg-gray-900 px-4 py-2 rounded-lg border border-white">
            <h3 className="text-sm font-semibold text-white">
              {platformLabels[platform] || `${platform.charAt(0).toUpperCase() + platform.slice(1)} Videos`}
            </h3>
            <span className="text-xs font-medium text-white bg-white/10 px-2 py-1 rounded">
              {groupedByPlatform[platform].length} video{groupedByPlatform[platform].length !== 1 ? 's' : ''}
            </span>
          </div>

          {/* Content Grid for this platform */}
          <ContentGridView
            content={groupedByPlatform[platform]}
            reportId={reportId}
            excludedContentIds={excludedContentIds}
            onContentExcluded={onContentExcluded}
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </div>
      ))}
    </div>
  );
};

export default VideoBySectionView;
